import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { InfoUsuarioService } from '../services/info-usuario.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioAutenticadoGuard implements CanActivate
{

  constructor(private jwtHelper: JwtHelperService, private router: Router, private infoUsuarioService: InfoUsuarioService) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  {
    if (this.infoUsuarioService.usuarioLogueado())
    {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
